/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LeadDto } from '../models/lead-dto';
import { LeadRouteAcceptanceDto } from '../models/lead-route-acceptance-dto';
import { LeadStatsDto } from '../models/lead-stats-dto';
import { SurveyDto } from '../models/survey-dto';
import { SurveyScratchDto } from '../models/survey-scratch-dto';
import { TargetLeadRouteDto } from '../models/target-lead-route-dto';

@Injectable({
  providedIn: 'root',
})
export class SurveyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getSurveys
   */
  static readonly GetSurveysPath = '/surveys';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveys()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveys$Response(params?: {
    companyId?: string;
    page?: number;
    size?: number;
  }): Observable<StrictHttpResponse<Array<SurveyDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.GetSurveysPath, 'get');
    if (params) {
      rb.query('companyId', params.companyId, {"style":"form","explode":false});
      rb.query('page', params.page, {"explode":false});
      rb.query('size', params.size, {"explode":false});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SurveyDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSurveys$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveys(params?: {
    companyId?: string;
    page?: number;
    size?: number;
  }): Observable<Array<SurveyDto>> {

    return this.getSurveys$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SurveyDto>>) => r.body as Array<SurveyDto>)
    );
  }

  /**
   * Path part for operation uploadCompanySurvey
   */
  static readonly UploadCompanySurveyPath = '/surveys';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadCompanySurvey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadCompanySurvey$Response(params: {
    companyId: string;
    body?: SurveyDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.UploadCompanySurveyPath, 'post');
    if (params) {
      rb.query('companyId', params.companyId, {"style":"form","explode":false});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadCompanySurvey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadCompanySurvey(params: {
    companyId: string;
    body?: SurveyDto
  }): Observable<void> {

    return this.uploadCompanySurvey$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getSurvey
   */
  static readonly GetSurveyPath = '/surveys/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurvey()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurvey$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<SurveyDto>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.GetSurveyPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSurvey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurvey(params: {
    id: string;
  }): Observable<SurveyDto> {

    return this.getSurvey$Response(params).pipe(
      map((r: StrictHttpResponse<SurveyDto>) => r.body as SurveyDto)
    );
  }

  /**
   * Path part for operation updateSurvey
   */
  static readonly UpdateSurveyPath = '/surveys/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurvey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSurvey$Response(params: {
    id: string;
    body?: SurveyDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.UpdateSurveyPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateSurvey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSurvey(params: {
    id: string;
    body?: SurveyDto
  }): Observable<void> {

    return this.updateSurvey$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation removeSurvey
   */
  static readonly RemoveSurveyPath = '/surveys/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeSurvey()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSurvey$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.RemoveSurveyPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeSurvey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSurvey(params: {
    id: string;
  }): Observable<void> {

    return this.removeSurvey$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getSurveyScratches
   */
  static readonly GetSurveyScratchesPath = '/surveys/scratches';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyScratches()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyScratches$Response(params?: {
    companyId?: string;
  }): Observable<StrictHttpResponse<Array<SurveyScratchDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.GetSurveyScratchesPath, 'get');
    if (params) {
      rb.query('companyId', params.companyId, {"style":"form","explode":false});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SurveyScratchDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSurveyScratches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyScratches(params?: {
    companyId?: string;
  }): Observable<Array<SurveyScratchDto>> {

    return this.getSurveyScratches$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SurveyScratchDto>>) => r.body as Array<SurveyScratchDto>)
    );
  }

  /**
   * Path part for operation uploadCompanySurveyScratch
   */
  static readonly UploadCompanySurveyScratchPath = '/surveys/scratches';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadCompanySurveyScratch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadCompanySurveyScratch$Response(params: {
    companyId: string;
    body?: SurveyScratchDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.UploadCompanySurveyScratchPath, 'post');
    if (params) {
      rb.query('companyId', params.companyId, {"style":"form","explode":false});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadCompanySurveyScratch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadCompanySurveyScratch(params: {
    companyId: string;
    body?: SurveyScratchDto
  }): Observable<void> {

    return this.uploadCompanySurveyScratch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getSurveyScratch
   */
  static readonly GetSurveyScratchPath = '/surveys/scratches/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyScratch()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyScratch$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<SurveyScratchDto>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.GetSurveyScratchPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyScratchDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSurveyScratch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyScratch(params: {
    id: string;
  }): Observable<SurveyScratchDto> {

    return this.getSurveyScratch$Response(params).pipe(
      map((r: StrictHttpResponse<SurveyScratchDto>) => r.body as SurveyScratchDto)
    );
  }

  /**
   * Path part for operation updateSurveyScratch
   */
  static readonly UpdateSurveyScratchPath = '/surveys/scratches/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurveyScratch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSurveyScratch$Response(params: {
    id: string;
    body?: SurveyScratchDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.UpdateSurveyScratchPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateSurveyScratch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSurveyScratch(params: {
    id: string;
    body?: SurveyScratchDto
  }): Observable<void> {

    return this.updateSurveyScratch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation removeSurveyScratch
   */
  static readonly RemoveSurveyScratchPath = '/surveys/scratches/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeSurveyScratch()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSurveyScratch$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.RemoveSurveyScratchPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeSurveyScratch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSurveyScratch(params: {
    id: string;
  }): Observable<void> {

    return this.removeSurveyScratch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getSurveyLeads
   */
  static readonly GetSurveyLeadsPath = '/surveys/{id}/leads';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyLeads()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyLeads$Response(params: {

    /**
     * Survey id
     */
    id: string;

    /**
     * (For debug purposes): returns all the leads associated with the survey
     */
    withDeleted?: boolean;
  }): Observable<StrictHttpResponse<Array<LeadDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.GetSurveyLeadsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('withDeleted', params.withDeleted, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LeadDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSurveyLeads$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyLeads(params: {

    /**
     * Survey id
     */
    id: string;

    /**
     * (For debug purposes): returns all the leads associated with the survey
     */
    withDeleted?: boolean;
  }): Observable<Array<LeadDto>> {

    return this.getSurveyLeads$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LeadDto>>) => r.body as Array<LeadDto>)
    );
  }

  /**
   * Path part for operation getTargetUserLeads
   */
  static readonly GetTargetUserLeadsPath = '/surveys/leads';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTargetUserLeads()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTargetUserLeads$Response(params?: {
    page?: number;
    size?: number;
  }): Observable<StrictHttpResponse<Array<TargetLeadRouteDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.GetTargetUserLeadsPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TargetLeadRouteDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTargetUserLeads$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTargetUserLeads(params?: {
    page?: number;
    size?: number;
  }): Observable<Array<TargetLeadRouteDto>> {

    return this.getTargetUserLeads$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TargetLeadRouteDto>>) => r.body as Array<TargetLeadRouteDto>)
    );
  }

  /**
   * Path part for operation getUserLeadsStats
   */
  static readonly GetUserLeadsStatsPath = '/surveys/leads/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserLeadsStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserLeadsStats$Response(params?: {
  }): Observable<StrictHttpResponse<Array<LeadStatsDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.GetUserLeadsStatsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LeadStatsDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserLeadsStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserLeadsStats(params?: {
  }): Observable<LeadStatsDto> {

    return this.getUserLeadsStats$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LeadStatsDto>>) => r.body as LeadStatsDto)
    );
  }

  /**
   * Path part for operation surveyLeadAcceptance
   */
  static readonly SurveyLeadAcceptancePath = '/surveys/leads/{leadId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `surveyLeadAcceptance()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  surveyLeadAcceptance$Response(params: {

    /**
     * Lead id
     */
    leadId: string;
    body?: LeadRouteAcceptanceDto
  }): Observable<StrictHttpResponse<TargetLeadRouteDto>> {

    const rb = new RequestBuilder(this.rootUrl, SurveyService.SurveyLeadAcceptancePath, 'post');
    if (params) {
      rb.path('leadId', params.leadId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TargetLeadRouteDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `surveyLeadAcceptance$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  surveyLeadAcceptance(params: {

    /**
     * Lead id
     */
    leadId: string;
    body?: LeadRouteAcceptanceDto
  }): Observable<TargetLeadRouteDto> {

    return this.surveyLeadAcceptance$Response(params).pipe(
      map((r: StrictHttpResponse<TargetLeadRouteDto>) => r.body as TargetLeadRouteDto)
    );
  }

}
